(function() {
  // Wait for jQuery + DOM
  function init() {
    if (typeof jQuery === 'undefined') {
      setTimeout(init, 50);
      return;
    }
    var $ = jQuery;
    var config = window.PiqueCartConfig || {};

    window.baseThreshold = config.freeShippingThreshold;
    window.baseCurrency  = config.currency;

    // ── Helpers ─────────────────────────────────────────────────────────────
    function getCookie(n) {
      for (var t = n + "=", r = document.cookie.split(";"), e = 0; e < r.length; e++) {
        for (var i = r[e]; " " == i.charAt(0);) i = i.substring(1, i.length);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return null;
    }

    function GetURLParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) return sParameterName[1];
      }
    }

    function paidProductsInCart(cart) {
      return cart.items.filter(function(item) {
        return item.id !== 40384172949602;
      }).length;
    }
    function getReferralCampaign() {
  // 1. Live URL parameter (original behavior)
  var fromUrl = GetURLParameter('utm_campaign');
  if (fromUrl) { return fromUrl; }

  // 2. sessionStorage: as-customer-trigger-data (only set when arriving via referral link)
  try {
    var trigger = sessionStorage.getItem('as-customer-trigger-data');
    if (trigger) {
      var parsed = JSON.parse(trigger);
      if (parsed && parsed.utm_campaign) { return parsed.utm_campaign; }
    }
  } catch (e) {}

  return undefined;
}

    // ── Cart API ─────────────────────────────────────────────────────────────
    Shopify.Cart = Shopify.Cart || {};
    Shopify.Cart.GiftWrap = {};
    var giftQueue = Promise.resolve();
    var pendingAdds = {};

    function enqueueGift(task) {
      giftQueue = giftQueue.then(task).catch(function(err) {
        console.error('GiftWrap queue error:', err);
      });
      return giftQueue;
    }

    Shopify.Cart.GiftWrap.set = function(variantid, quantity) {
  // Skip if this gift is already being added in this cycle
  if (pendingAdds[variantid]) { return giftQueue; }
  pendingAdds[variantid] = true;

  return enqueueGift(function() {
    // Re-check live cart right before adding, so we never double-add
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var existing = cart.items.find(function(i) { return i.id === variantid; });
        if (existing) { return; } // already in cart, do nothing
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' }),
          body: JSON.stringify({ id: variantid, quantity: 1 }) // force qty 1
        }).then(function() {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: variantid, quantity: 1 }
          }));
        });
      })
      .finally(function() { pendingAdds[variantid] = false; });
  });
};

    Shopify.Cart.GiftWrap.remove = function(productId) {
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { quantity: 0, id: productId }
      }).then(function() {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: productId, quantity: 0 }
        }));
      });
    };

    // ── Core cart recalc ─────────────────────────────────────────────────────
    function recalcEnroute() {
      jQuery.getJSON('/cart.js', function(cart) {
        var total_price = cart.total_price / 100;
        var utm_cookie_value    = getCookie("__attentive_utm_param_campaign");
        var refferal_cookie_value = getReferralCampaign();
        var product_ttl         = GetURLParameter('utm_campaign');
        var product_affliate    = GetURLParameter('utm_source');
        var product_medium      = GetURLParameter('utm_medium');

        var hasBundleItems = false;
        cart.items.forEach(function(item) {
          if (item.properties && item.properties._subscription_bundle === 'true') {
            hasBundleItems = true;
          }
        });
        if(cart.discount_codes.length === 0 && hasBundleItems){
                        document.cookie = 'discount_code="20OFFSUB"; path=/';
                        fetch('/discount/20OFFSUB')
                        .then(function() {
                          return fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                              updates: {},
                            }),
                          });
                        })
                        .catch(function(error) {
                          console.error('Error:', error);
                        });
                }
        
        var currency   = Shopify.currency.active;
        var threshold  = window.baseThreshold;
        var totalPrice = total_price;

        var carraraInCart = false, carraraScoopInCart = false, carraraKitInCart = false, carraraWelcomeKIt = false, carraraKitSubInCart= false, dhpGiftInCart2 = false;
        var dhpComp1Sub = false, dhpComp2Sub = false, rsdComp1Sub = false, rsdComp2Sub = false, nandakaSub = false;
        var b, c, e, d, p, q, r, x, y, z, x2, y2, d1, z1, d2, b1, p1, p2, p3, p4, n, n1, n2, f, ret, retq, fb, o;
        var selling_plans_nandak, n3, n4, n5, selling_plans_nandak_hbp, selling_plans_3;
        var final_price_lineitem_nandaka, n6, n7, n8, p5, p6, s, n9, n10, n11;
        var selling_plans_pbs, y1, d12, selling_plans1, z2, x1, e1, r1, d13, pb, pbf, pb1, hb, hbf, hb1;
        var g;

        cart.items.forEach(function(a) {
          if (a.id === 42754775351394) { x = a.quantity; carraraInCart = true; }
          if (a.id === 42772944650338) { carraraScoopInCart = true; g = a.quantity; }
          if (a.id === 41406427463778) { o = a.id; }
          if (a.id === 42199912972386) { c = a.id; }
          if (a.id === 43177274146914) { carraraKitInCart = true; }
          if (a.id === 43177274146914 && a.selling_plan_allocation) { carraraKitSubInCart = true; }
          if (a.id === 43334710329442) { p1 = a.id; carraraWelcomeKIt = true; }
          if (a.id === 43227330052194 && a.selling_plan_allocation) { nandakaSub = true; }
          if (Number(a.properties && a.properties._bundle_parent) === 43206238044258 && a.selling_plan_allocation) {
          if (a.id === 39579586723938) { dhpComp1Sub = true; }
          if (a.id === 41962239787106) { dhpComp2Sub = true; }
         }
         if (Number(a.properties && a.properties._bundle_parent) === 43206212485218 && a.selling_plan_allocation) {
            if (a.id === 39579586723938) { rsdComp1Sub = true; }
            if (a.id === 15760607576162) { rsdComp2Sub = true; }
          }
          if (a.id === 42609638244450) { dhpGiftInCart2 = true; }
        });
        var dhpBundleQualifies = dhpComp1Sub && dhpComp2Sub;
        var rsdBundleQualifies = rsdComp1Sub && rsdComp2Sub;
        
        var needsScoop = carraraInCart || carraraKitInCart;

        if (needsScoop && !carraraScoopInCart) {
          Shopify.Cart.GiftWrap.set(42772944650338, 1);
        } else if (!needsScoop && carraraScoopInCart) {
          Shopify.Cart.GiftWrap.remove(42772944650338);
        }

        var welcomeKitQualifies = carraraKitSubInCart || rsdBundleQualifies || nandakaSub;
        
        if (welcomeKitQualifies && !carraraWelcomeKIt) {
          Shopify.Cart.GiftWrap.set(43334710329442, 1);
        } else if (!welcomeKitQualifies && carraraWelcomeKIt) {
          Shopify.Cart.GiftWrap.remove(43334710329442);
        }

        if (dhpBundleQualifies && !dhpGiftInCart2) {
          Shopify.Cart.GiftWrap.set(42609638244450, 1);
        } else if (!dhpBundleQualifies && dhpGiftInCart2) {
          Shopify.Cart.GiftWrap.remove(42609638244450);
        }
        if (o === 41406427463778) { Shopify.Cart.GiftWrap.remove(41406427463778); }
        if (c === 42199912972386) { Shopify.Cart.GiftWrap.remove(42199912972386); }

        var starterKitA = 42609635852386;
        var starterKitB = 42402129051746;
        var hasStarterKitA = false, hasStarterKitB = false;

        cart.items.forEach(function(item) {
          if (item.id === starterKitA) { hasStarterKitA = true; }
          if (item.id === starterKitB) { hasStarterKitB = true; }
        });

        // ── Gift wrap logic ────────────────────────────────────────────────
        var applyGiftWrap = config.applyGiftWrap;
        if (applyGiftWrap) {
          var dhpBundle = 42060262309986, liverBundle = 41740812648546, puerBundle = 29692103032930;
          var dhpGift = 42609638244450, commonGift = 42402129051746, byobGift = 39986972557410;
          var mothersDayBundle = 42838823665762, mothersDayGift = 42838950969442;
          var lpGiftIds = [40452231299170];
          var hasDhpBundle = false, hasLiverBundle = false, hasPuerBundle = false;
          var dhpGiftInCart = false, commonGiftInCart = false, finalPriceGiftCard, g11, byobGiftInCart = false;
          var hasSubscriptionProduct = false;
          var subscriptionTotal = 0;
          var hasMotherssDayBundleSubscription = false, mothersDayGiftInCart = false, hasLpGift = false;
          var bottleMeetsMinimum = totalPrice >= 115;

          cart.items.forEach(function(item) {
            if (item.id == dhpBundle)      { hasDhpBundle = true; }
            if (item.id == liverBundle)    { hasLiverBundle = true; }
            if (item.id == puerBundle)     { hasPuerBundle = true; }
            if (item.id == dhpGift)        { dhpGiftInCart = true; }
            if (item.id == commonGift)     { commonGiftInCart = true; }
            if (item.id == mothersDayGift) { mothersDayGiftInCart = true; }
            if (lpGiftIds.indexOf(item.id) !== -1) { hasLpGift = true; }
            if (item.gift_card) { g11 = item.quantity; finalPriceGiftCard = item.final_line_price; }
            if (item.selling_plan_allocation) {
              var isBundleSubscription = item.properties && item.properties._subscription_bundle == 'true';
              if (!isBundleSubscription) { hasSubscriptionProduct = true; }
              subscriptionTotal += item.final_line_price;
            }
            if (item.id == mothersDayBundle) { hasMotherssDayBundleSubscription = true; }
          });

          if (g11 >= 1) totalPrice -= finalPriceGiftCard / 100;

          if (hasMotherssDayBundleSubscription) {
            if (!mothersDayGiftInCart) { Shopify.Cart.GiftWrap.set(mothersDayGift, 1); }
            if (commonGiftInCart)      { Shopify.Cart.GiftWrap.remove(commonGift); }
          } else {
            if (mothersDayGiftInCart)  { Shopify.Cart.GiftWrap.remove(mothersDayGift); }
            
            var meetsOrderMinimum      = (subscriptionTotal / 100) >= 120;
            console.log(meetsOrderMinimum);
            var qualifiesForWelcomeKit = meetsOrderMinimum && hasSubscriptionProduct && !hasLpGift && !hasStarterKitA && !carraraWelcomeKIt && !dhpGiftInCart2;
             console.log(qualifiesForWelcomeKit);
            if (qualifiesForWelcomeKit) {
              if (!commonGiftInCart) { Shopify.Cart.GiftWrap.set(commonGift, 1); }
            } else {
              if (commonGiftInCart)  { Shopify.Cart.GiftWrap.remove(commonGift); }
            }
            if (carraraWelcomeKIt && commonGiftInCart) {
              Shopify.Cart.GiftWrap.remove(commonGift);
            }
            if (dhpGiftInCart2 && commonGiftInCart) {
              Shopify.Cart.GiftWrap.remove(commonGift);
            }
          }
           var lpThresholdMet = (subscriptionTotal / 100) >= 100;

            if (hasLpGift && !lpThresholdMet) {
              Shopify.Cart.GiftWrap.remove(40452231299170);
            }
            if (byobGiftInCart && !bottleMeetsMinimum) { Shopify.Cart.GiftWrap.remove(byobGift); }
        } else {
          var dhpBundle = 42060262309986, liverBundle = 41740812648546, puerBundle = 29692103032930;
          var dhpGift = 39986972557410, commonGift = 40452231299170, siteCommonGift = 42609800282210;
          var hasDhpBundle = false, hasLiverBundle = false, hasPuerBundle = false;
          var dhpGiftInCart = false, commonGiftInCart = false, siteCommonGiftInCart = false;
          var bundleSubtotal = 0;

          cart.items.forEach(function(item) {
            var parentId = Number(item.properties && item.properties._bundle_parent);
            var isSub    = item.selling_plan_allocation;
            if (isSub) { bundleSubtotal += item.original_line_price; }
            if (parentId === dhpBundle   && isSub && bundleSubtotal > 10000) { hasDhpBundle = true; }
            if (parentId === liverBundle && isSub) { hasLiverBundle = true; }
            if (parentId === puerBundle  && isSub) { hasPuerBundle = true; }
            if (item.id == dhpGift)        { dhpGiftInCart = true; }
            if (item.id == commonGift)     { commonGiftInCart = true; }
            if (item.id == siteCommonGift) { siteCommonGiftInCart = true; }
          });

          function syncGift(shouldHave, inCart, giftId) {
            if (shouldHave && !inCart)  { Shopify.Cart.GiftWrap.set(giftId, 1); }
            if (!shouldHave && inCart)  { Shopify.Cart.GiftWrap.remove(giftId); }
          }

          syncGift(hasDhpBundle, dhpGiftInCart, dhpGift);
          if (hasDhpBundle && commonGiftInCart) { Shopify.Cart.GiftWrap.remove(commonGift); }

          if (!hasDhpBundle) {
            var qualifies = bundleSubtotal >= 10000 || hasLiverBundle || hasPuerBundle;
            syncGift(qualifies, commonGiftInCart, commonGift);
          }
          if (siteCommonGiftInCart) { Shopify.Cart.GiftWrap.remove(siteCommonGift); }
        }

        // ── Additional gift/variant logic ──────────────────────────────────
        var hasSubscription = false;
        var bundleSubtotal2 = 0;
        cart.items.forEach(function(a) {
          if (a.id === 42609800282210) { p1 = a.id; }
          if (a.id === 42402135605346) { p2 = a.id; }
          if (a.id === 42609635852386) { p3 = a.id; }
          if (a.id === 42060262309986) { retq = a.quantity; ret = a.id; selling_plans_3 = a.selling_plan_allocation; }
          if (a.id === 40452231299170) { f = a.id; }
          if (a.selling_plan_allocation != null) { hasSubscription = true; bundleSubtotal2 += a.original_line_price; }
        });

        if (p2 === 42402135605346) { Shopify.Cart.GiftWrap.remove(42402135605346); }
        if (p3 === 42609635852386 && bundleSubtotal2 < 10000) { Shopify.Cart.GiftWrap.remove(42609635852386); }
        if (hasStarterKitA && hasStarterKitB) {
          Shopify.Cart.GiftWrap.remove(starterKitB);
        }

        // ── Referral candy free product ────────────────────────────────────
        if (typeof refferal_cookie_value !== "undefined" && refferal_cookie_value && refferal_cookie_value.includes("referralcandy_")) {
          var freeProductId    = 40384172949602;
          var hasPaidProducts  = paidProductsInCart(cart) > 0;
          var hasFreeProduct   = cart.items.some(function(item) { return item.id === freeProductId; });
          var isCartSubtotalZero = cart.total_price === 0;
          if (hasPaidProducts && !hasFreeProduct && !isCartSubtotalZero) {
            Shopify.Cart.GiftWrap.set(freeProductId, 1);
          } else if ((!hasPaidProducts) && hasFreeProduct) {
            Shopify.Cart.GiftWrap.remove(freeProductId);
          }
        }

        // ── Page-specific logic (uses config flags instead of Liquid) ──────
        var u, h, h3, h4, g4, u4;

        if (config.isTimPage) {
          cart.items.forEach(function(a) {
            if (a.id === 31767730487394) { u = a.quantity; s = a.id; }
            if (a.id === 39611069464674) { h = a.id; g = a.quantity; }
          });
          if (u >= 1 && h !== 39611069464674)   { Shopify.Cart.GiftWrap.set(39611069464674, 1); }
          else if (s != 31767730487394 && h === 39611069464674) { Shopify.Cart.GiftWrap.remove(39611069464674); }
          if (s == 31767730487394) {
            $(".RelatedProduct__Slider:first-child").hide();
            $(".RelatedProduct__Slider[data-prodid='40294838272098']").show();
          }
        }

        if (config.isSubscriptionCollection) {
          var selling_plan_arry = [], sell_count = 0;
          cart.items.forEach(function(a) {
            selling_plan_arry = a.selling_plan_allocation;
            if (selling_plan_arry === undefined) { sell_count++; }
            if (a.id === 40354746794082) { h3 = a.id; g = a.quantity; }
          });
          if (total_price >= 100 && h3 !== 40354746794082 && sell_count < 1) {
            Shopify.Cart.GiftWrap.set(40354746794082, 1);
          } else if ((total_price < 100 || sell_count > 1) && h3 === 40354746794082) {
            Shopify.Cart.GiftWrap.remove(40354746794082);
          }
        } else {
          cart.items.forEach(function(a) {
            if (a.id === 40354746794082) { h3 = a.id; g = a.quantity; }
          });
          if (total_price < 100 && h3 === 40354746794082) {
            Shopify.Cart.GiftWrap.remove(40354746794082);
          }
        }

        if (config.isPuerSpecial) {
          cart.items.forEach(function(a) {
            if (a.id === 29692103032930) { u = a.quantity; s = a.id; }
            if (a.id === 39611069464674) { h = a.id; g = a.quantity; }
          });
          if (u >= 1 && h !== 39611069464674)   { Shopify.Cart.GiftWrap.set(39611069464674, 1); }
          else if (s != 29692103032930 && h === 39611069464674) { Shopify.Cart.GiftWrap.remove(39611069464674); }
        }

        // ── UTM campaign logic ─────────────────────────────────────────────
        if (typeof product_ttl !== "undefined" && product_ttl === 'freesampler') {
          cart.items.forEach(function(a) {
            if (a.id === 39441631346786) { h = a.id; g = a.quantity; }
          });
          if (total_price >= 110 && h !== 39441631346786)   { Shopify.Cart.GiftWrap.set(39441631346786, 1); }
          else if (total_price < 110 && h === 39441631346786) { Shopify.Cart.GiftWrap.remove(39441631346786); }
        }

        var u5, p5;
        if ((product_affliate !== "undefined" && product_affliate === 'affiliate') ||
            config.pageHandle === 'pique-beauty-bt-offers' || config.pageHandle === 'pique-beauty-bt') {
          cart.items.forEach(function(a) {
            if (a.id === 39772516319330) { u5 = a.quantity; p5 = a.id; }
            if (a.id === 41453574717538) { h = a.id; }
          });
          if (u5 >= 1 && h !== 41453574717538)     { Shopify.Cart.GiftWrap.set(41453574717538, 1); }
          else if (p5 !== 39772516319330 && h === 41453574717538) { Shopify.Cart.GiftWrap.remove(41453574717538); }
        } else {
          cart.items.forEach(function(a) {
            if (a.id === 39843214786658) { u4 = a.quantity; p4 = a.id; }
            if (a.id === 41453574717538) { h = a.id; h4 = a.id; }
          });
          if (u4 < 2 && h4 === 41453574717538)     { Shopify.Cart.GiftWrap.remove(41453574717538); }
          else if (p4 !== 39843214786658 && h === 41453574717538) { Shopify.Cart.GiftWrap.remove(41453574717538); }
        }

        if (typeof product_ttl !== "undefined" && product_ttl === 'vcsampler') {
          cart.items.forEach(function(a) {
            if (a.id === 32068087021666) { u = a.quantity; }
            if (a.id === 39441631346786) { h = a.id; }
          });
          if (u >= 2 && h !== 39441631346786)  { Shopify.Cart.GiftWrap.set(39441631346786, 1); }
          else if (u < 2 && h === 39441631346786) { Shopify.Cart.GiftWrap.remove(39441631346786); }
        }

        // ── Single gift wrap item cleanup ──────────────────────────────────
        var giftWrapIds = [39611069464674, 39548746236002, 40384172949602, 40217016500322,
          41453574717538, 42402129051746, 42402135605346, 42584519770210,
          40452231299170, 42220643221602, 42772944650338, 42838950969442, 42838975447138];

        if (cart.item_count === 1) {
          var quantities = {};
          cart.items.forEach(function(item) {
            if (giftWrapIds.includes(item.id)) { quantities[item.id] = item.quantity; }
          });
          giftWrapIds.forEach(function(id) {
            if (quantities[id] === 1) { Shopify.Cart.GiftWrap.remove(id); }
          });
        }
      });
    }

    // ── Cart update polling ─────────────────────────────────────────────────
    function checkCartUpdate() {
      $.ajax({
        url: '/cart.js', method: 'GET', dataType: 'json',
        success: function() { recalcEnroute(); },
        error: function(error) { console.log("Error fetching cart:", error); }
      });
    }

    var recalcTimer;
    function debouncedRecalc(delay) {
      clearTimeout(recalcTimer);
      recalcTimer = setTimeout(recalcEnroute, delay || 600);
    }

    recalcEnroute();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // ── Event listeners ─────────────────────────────────────────────────────
    $(document).on("change", "select.QuantitySelector__CurrentQuantity", function() {
      setTimeout(checkCartUpdate, 720);
    });
    $(document).on("click", ".CartItem__Remove[data-action='remove-item']", function() {
      setTimeout(checkCartUpdate, 720);
    });
    $('[data-cart-action="subscription"],[data-cart-action="onetime"]').click(function() { setTimeout(checkCartUpdate, 800); });
    $('#mix_main_product').click(function() { setTimeout(checkCartUpdate, 800); });
    $('#mix_main_product_otp').click(function() { setTimeout(checkCartUpdate, 720); });
    $(document).on("click", ".PT242__OptionWidget--Button", function() {
      setTimeout(checkCartUpdate, 700);
    });
    document.addEventListener('product:added', function() { debouncedRecalc(800); });

    $(document).on('change', '.Cart__UpsellQuantity', function() {
      var qunatity_val = this.value;
      $(this).closest(".Swiper__AddAction").find(".Swiper__AddToCart").attr('data-quantity', qunatity_val);
    });

    $(document).on("change", "select[name='selling-plan']", function(e) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: e.target.dataset.line,
          quantity: e.target.dataset.quantity,
          selling_plan: e.target.value,
          properties: { _no_discount: "true" }
        })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        recalcEnroute();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }).catch(function(error) { console.error('Error:', error); });
    });

    // ── Cart helpers ────────────────────────────────────────────────────────
    function updatePurchasePlan(line, qty, sellingplan) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, selling_plan: sellingplan, properties: { _no_discount: "true" } })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        recalcEnroute();
      }).catch(function(error) { console.error('Error:', error); });
    }

    $(document).on("click", "#hs-item-cart-subscription", function(e) {
      e.preventDefault();
      updatePurchasePlan(e.target.dataset.line, e.target.dataset.quantity, e.target.dataset.sellingplan);
    });
    $(document).on("click", "#hs-item-cart-onetime", function(e) {
      e.preventDefault();
      updatePurchasePlan(e.target.dataset.line, e.target.dataset.quantity, e.target.dataset.sellingplan);
    });

    function addUpsellToCart(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          recalcEnroute();
        }
      });
    }

    function addItemToCart(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (config.isSidebarCart) {
            if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
              $("#sidebar-cart").attr("aria-hidden", false);
            }
          } else {
            $('.cart_dr')[0].click();
          }
          recalcEnroute();
        }
      });
    }

    function addItemToCartCollection(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          $('.cart_dr')[0].click();
          recalcEnroute();
        }
      });
    }

    function addBundleToCartHome(itemsArray) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsArray })
      }).then(function(res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
          $("#sidebar-cart").attr("aria-hidden", false);
        }
        recalcEnroute();
        $('.js-modal-close').trigger('click');
      }).catch(function(error) { console.error(error); alert('Could not add bundle.'); });
    }

    function addBundleToCart(variant_id, quantity, selling_plan) {
      var data = { id: variant_id, quantity: quantity };
      if (selling_plan) { data.selling_plan = selling_plan; data.properties = { _no_discount: "true" }; }
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js', data: data, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
            $("#sidebar-cart").attr("aria-hidden", false);
          }
          recalcEnroute();
        }
      });
    }

    function buildBundleItems(variantId, bundleDataRaw, sellingPlanId) {
      var bundleGroupId = Date.now();
      if (!bundleDataRaw) {
        var item = { id: Number(variantId), quantity: 1, properties: { _no_discount: "true" } };
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        return [item];
      }
      return JSON.parse(bundleDataRaw).map(function(item) {
        var itemObj = {
          id: item.id, quantity: 1,
          properties: { _bundle_id: bundleGroupId, _bundle_parent: variantId, _no_discount: "true" }
        };
        if (sellingPlanId && item.selling_plan) itemObj.selling_plan = item.selling_plan;
        return itemObj;
      });
    }

    $(document).on('click', '.upsell_cart', function() {
      addUpsellToCart($(this).attr("data-var_id"), $(this).attr("data-quantity"));
    });
    $('.ad_to_cart_coll').click(function() {
      addItemToCart($(this).attr("data-var_id"), 1);
    });
    $(document).on('click', '.ad_to_cart_collect', function() {
      addItemToCartCollection($(this).attr("data-var_id"), 1);
    });

    $(document).on('click', '.subscription_addtocart_cart', function(e) {
      e.preventDefault();
      var parentVariantId = $(this).attr('data-var_id');
      var bundleDataRaw   = $(this).attr('data-bundle-data');
      var bundleGroupId   = Date.now();
      if (bundleDataRaw) {
        var itemsToAdd = JSON.parse(bundleDataRaw).map(function(item) {
          return { id: item.id, quantity: 1, selling_plan: item.selling_plan,
            properties: { _bundle_id: bundleGroupId, _bundle_parent: parentVariantId, _no_discount: "true" } };
        });
        addBundleToCartHome(itemsToAdd);
      } else {
        var Freq = $(this).siblings('.rc_shipping_interval_frequency').find(":selected").val();
        addBundleToCart($(this).siblings("input[name='id']").val(), parseInt($(this).attr('data-qantity')), Freq);
      }
    });

    $('.subscription_addtocart_item, .subscription_addtocart').click(function(e) {
      e.preventDefault();
      var parentVariantId = $(this).attr('data-var_id');
      var bundleDataRaw   = $(this).attr('data-bundle-data');
      var bundleGroupId   = Date.now();
      if (bundleDataRaw) {
        var itemsToAdd = JSON.parse(bundleDataRaw).map(function(item) {
          return { id: item.id, quantity: 1, selling_plan: item.selling_plan,
            properties: { _bundle_id: bundleGroupId, _bundle_parent: parentVariantId, _no_discount: "true" } };
        });
        addBundleToCartHome(itemsToAdd);
      } else {
        var freq = $(this).siblings('.rc_shipping_interval_frequency').find(":selected").val();
        addBundleToCartHome([{ id: parentVariantId, quantity: 1, selling_plan: freq, properties: { _no_discount: "true" } }]);
      }
    });

    document.addEventListener("click", function(e) {
      var homeBtn = e.target.closest(".js-bundle");
      if (homeBtn) {
        e.preventDefault();
        addBundleToCartHome(buildBundleItems(
          homeBtn.getAttribute("data-var_id"),
          homeBtn.getAttribute("data-bundle-data"),
          homeBtn.getAttribute("data-selling-plan") || null
        ));
      }
      var pdpBtn = e.target.closest(".pdpBundleBtn");
      if (pdpBtn) {
        e.preventDefault();
        var sellingPlanId = document.querySelector('input[name="selling_plan"]');
        addBundleToCartHome(buildBundleItems(
          pdpBtn.getAttribute("data-var_id"),
          pdpBtn.getAttribute("data-bundle-data"),
          sellingPlanId ? sellingPlanId.value.trim() || null : null
        ));
      }
    });

    // Expose functions globally for any inline calls elsewhere in theme
    window.PiqueCart = {
      addItemToCart: addItemToCart,
      addItemToCartCollection: addItemToCartCollection,
      addUpsellToCart: addUpsellToCart,
      addBundleToCart: addBundleToCart,
      addBundleToCartHome: addBundleToCartHome,
      recalcEnroute: recalcEnroute
    };
  }

  init();
})();